<div class="myc-sticky-top" #stickyTop>
    <currency-mismatch-banner [currencies]="currencies"></currency-mismatch-banner>

    <comparison-controls-bar
        [yearLabels]="harmonized.yearLabels"
        [selectedYears]="controls.selectedYears"
        [deltaMode]="controls.deltaMode"
        [reportScope]="controls.reportScope"
        [structMode]="controls.structMode"
        [hasReferenceValue]="!!harmonized.referenceNodeId"
        [isAllExpanded]="isAllExpanded"
        [exportInFlight]="exportInFlight"
        [availableLanguages]="harmonized.availableLanguages || []"
        [activeLanguage]="harmonized.activeLanguage || null"
        (yearToggled)="yearToggled.emit($event)"
        (deltaModeChanged)="deltaModeChanged.emit($event)"
        (reportScopeChanged)="reportScopeChanged.emit($event)"
        (structModeToggled)="structModeToggled.emit()"
        (showAllDetails)="showAllDetails.emit()"
        (hideAllDetails)="hideAllDetails.emit()"
        (exportPdf)="exportPdf.emit()"
        (languageChanged)="languageChanged.emit($event)">
    </comparison-controls-bar>
</div>

<harmonized-comparison-table
    [harmonized]="harmonized"
    [controls]="controls"
    [style.--table-header-top]="stickyTopHeight + 'px'"
    (nodeToggled)="nodeToggled.emit($event)">
</harmonized-comparison-table>
